const updateMembersErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateMembersErrors;
